// ============================================================================
// MÓDULO 1: CONFIGURAÇÃO MESTRA (INFRA & DESIGN SYSTEM)
// ARQUIVO: src/config/Config.jsx
// VERSÃO: 4.7 - DOPPLER-FIRST (env vars prioritárias, sem fallback hardcoded)
// OBJETIVO: Forçar uso do Doppler em todos os ambientes.
// ============================================================================

import { LOCAL_ASSETS } from "./LocalAssets";

// --- 1. DESIGN SYSTEM ---
export const DESIGN_SYSTEM = {
  colors: {
    brandBlue: "#20243B",
    brandBlueDarker: "#1a1e30",
    textPrimary: "#374151",
    borderLight: "#e5e7eb",
    highlightAction: "#C5A059",
    bgLight: "#f8fafc",
    security: {
      noticeBg: "#e0f2fe",
      noticeBorder: "#38bdf8",
      noticeText: "#0369a1",
    },
  },
  fonts: {
    primary: "'Inter', sans-serif",
    icons: "FontAwesome 6.4.0",
  },
};

// --- TRAVA DE SEGURANÇA (DEPLOY) ---
export const ENABLE_ACADEMIA_PUBLIC = false;

// --- PLANOS & MONETIZAÇÃO ---
export const PLANS = {
  FREE: {
    id: "free",
    label: "Plano Gratuito",
    features: ["Simulado Express", "Dashboard Básico"],
  },
  PRO: {
    id: "pro",
    label: "RDA Pro",
    price: "R$ 49,90/mês",
    features: ["Vídeo Aulas", "Banco de Peças", "Laboratório Mentoria"],
  },
};

// --- 2. DADOS INSTITUCIONAIS ---
export const LAW_FIRM_INFO = {
  name: "Rodrigo Demeterco",
  title: "Advocacia & Educação Jurídica",
  oab: "OAB/PR 113.938",
  address: "Rua Bom Jesus de Iguape, 2035 - Hauer, Curitiba - PR, 81610-040",
  contact: {
    phone: "(41) 99848-1711",
    email: "contato@rodrigodemeterco.adv.br",
    whatsappLink: "https://wa.me/5541998481711",
    photoURL: "",
  },
  social: {
    linkedin: "#",
    instagram: "#",
  },
};

// --- 2B. CASE TEAM — SEED DO TITULAR (Art. 327) ---
export const CASE_TEAM_ROLES = {
  LEAD: "LEAD",
  ASSOCIATE: "ASSOCIATE",
  COCOUNSEL: "COCOUNSEL",
  PARALEGAL: "PARALEGAL",
};
export const TITULAR_SEED = {
  clientId: "__TITULAR__",
  name: LAW_FIRM_INFO.name,
  oab: LAW_FIRM_INFO.oab,
  role: CASE_TEAM_ROLES.LEAD,
  phone: LAW_FIRM_INFO.contact.phone,
  whatsappLink: LAW_FIRM_INFO.contact.whatsappLink,
  email: LAW_FIRM_INFO.contact.email,
  photoURL: LAW_FIRM_INFO.contact.photoURL || "",
};

// --- 3. CONFIGURAÇÃO FIREBASE (DOPPLER-FIRST) ---
// A apiKey Firebase é injetada exclusivamente pelo Doppler.
// Use `doppler run -- npm run dev` para desenvolvimento.
// Use `doppler run -- npm run build && firebase deploy --only hosting` para produção.
// NÃO há fallback hardcoded — se a env var não existir, o Firebase não inicializa.

export const PROJECT_ID =
  import.meta.env.VITE_FIREBASE_PROJECT_ID || "portalrda-f312d";

export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    PROJECT_ID + ".firebaseapp.com",
  projectId: PROJECT_ID,
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    PROJECT_ID + ".firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

if (!FIREBASE_CONFIG.apiKey) {
  console.warn(
    " RDA INFRA: VITE_FIREBASE_API_KEY não definida. Use Doppler: doppler run -- npm run dev",
  );
}

console.log(
  " RDA INFRA: Configuração carregada. ProjectID: " + PROJECT_ID + " [v4.7]",
);

// --- 4. ASSETS ---
export const ASSETS = {
  logoIcon: LOCAL_ASSETS.logoIcon,
  logoName: LOCAL_ASSETS.logoName,
  bannerHero: LOCAL_ASSETS.bannerHero,
  placeholder:
    "https://placehold.co/600x400/20243B/FFFFFF?text=Justiça+Conceitual",
};
